import { Modal } from 'antd';
import styled from 'styled-components';

export const StyledEnvironmentWall = styled(Modal)`
  .ant-modal-content {
    height: 90vh;
    padding: 50px;

    .ant-modal-body {
      font-size: 20px;
      display: flex;
      flex-direction: column;
      gap: 40px;

      .title {
        font-size: 24px;
        font-weight: bold;
      }

      .text-with-button {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px;

        .ant-input-group {
          width: auto;
          display: flex;
          align-items: center;

          .input {
            width: 200px;
          }
        }
      }
    }
  }
`;
